import React, { useState, useEffect } from 'react';
import './Projects.css';

// Add custom titles here using exact file names from src/recentProject
const CUSTOM_PROJECT_NAMES = {
  'Commercial-Building-MD-USA-1-768x512.jpg': 'Commercial Building, MD USA',
  'Industrial-Building-AR-USA-1-768x512.jpg': 'Industrial Building, AR USA',
  'projects-structural-miscellanieous-steel-768x529.png': 'Structural & Miscellaneous Steel',
  '1.jpeg':'Commercial project',
  '2.jpeg':'Commercial project',
  '3.jpeg':'Commercial project',
  '4.jpeg':'Commercial project',
  '5.jpeg':'Commercial project',
  '6.jpeg':'Commercial project'
};

const formatTitleFromFilename = (filename) => {
  const nameWithoutExtension = filename.replace(/\.[^/.]+$/, '');

  return nameWithoutExtension
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
};

const getRecentProjectImages = () => {
  const images = require.context('../recentProject', false, /\.(png|jpe?g|webp|gif)$/i);

  return images.keys().map((key) => {
    const fileName = key.replace('./', '');
    const customTitle = CUSTOM_PROJECT_NAMES[fileName];
    const projectTitle = customTitle || formatTitleFromFilename(fileName);

    return {
      src: images(key),
      alt: projectTitle,
      title: projectTitle
    };
  });
};

const Projects = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const recentProjects = getRecentProjectImages();

  const nextSlide = () => {
    if (recentProjects.length <= 1) return;
    setCurrentSlide((prev) => (prev + 1) % recentProjects.length);
  };

  const prevSlide = () => {
    if (recentProjects.length <= 1) return;
    setCurrentSlide((prev) => (prev - 1 + recentProjects.length) % recentProjects.length);
  };

  // Auto-advance slides every 4 seconds
  useEffect(() => {
    if (recentProjects.length <= 1) return undefined;

    const interval = setInterval(nextSlide, 4000);
    return () => clearInterval(interval);
  }, [recentProjects.length]);


  return (
    <section className="projects" id="projects">
      <div className="container">
        <h2 className="section-title">Most Recent Projects</h2>
        <p className="projects-subtitle">
          view all projects
        </p>
        
        {recentProjects.length > 0 ? (
          /* Recent Projects Slider */
          <div className="recent-projects-slider">
            <div className="slider-container">
              <div className="slider-wrapper">
                <button className="slider-btn prev-btn" onClick={prevSlide}>
                  &#8249;
                </button>

                <div className="slider-track">
                  <div
                    className="slides-container"
                    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                  >
                    {recentProjects.map((project, index) => (
                      <div key={index} className="slide">
                        <div className="slide-content">
                          <img
                            src={project.src}
                            alt={project.alt}
                            className="slider-image"
                          />
                          <div className="slide-overlay">
                            <h3 className="slide-title">{project.title}</h3>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <button className="slider-btn next-btn" onClick={nextSlide}>
                  &#8250;
                </button>
              </div>
            </div>
          </div>
        ) : (
          <p className="projects-subtitle">No project images found in recentProject folder.</p>
        )}

      </div>
    </section>
  );
};

export default Projects;

